<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('click', this.doAudio);
    });
  },
  methods: {
    doAudio() {
      () => {
        const audio = document.querySelector('#mp3');
        audio.play();
        document.removeEventListener('click', this.doAudio);
      };
    }
  }
};
</script>

<style>
#app {
  height: 100%;
  box-sizing: border-box;
}

.status-omit-colum .cell{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue